import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import PendingPaymentMade from 'components/Tvendo/Bank/Operations/Payments/PendingPaymentSharedFile.js';

export default function () {
  return (
    <PendingPaymentMade
      title="Listado de proveedores pendientes de pagos"
      excelName="Proveedores-pendientes-pago"
      entity="sap/provider/creditors"
      permission={ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_STORE}
    />
  );
}
